module.exports = __webpack_public_path__ + "static/media/stoutty.80ede7b6.png";